<div
  class="mt-5 mb-5 p-4 rounded-lg shadow-md w-full bg-white"
  [ngClass]="{ 'border border-red-500': error }"
  appInViewport
  (visibleChange)="onVisibilityChange($event)"
>
  <div
    class="border-b-primary-900 flex justify-between px-2 pb-1 items-center cursor-pointer"
    [ngClass]="{ 'border-b-2': !small, 'border-b': small }"
    (click)="hide()"
  >
    <div
      class="flex justify-center items-center"
      [ngClass]="{ 'flex-1 justify-between': cerrar, }"
    >
      <h1
        class="mr-4"
        [ngClass]="{ 'text-2xl': !small, 'base font-bold': small }"
      >
        {{ titulo }}
      </h1>
      @if(ayuda) {
      <section
        class="relative flex justify-center items-center"
        (click)="
          otherAction = true;
          show == false ? (show = true) : fx ? fx() : ayudaClick()
        "
      >
        <div
          class="group flex justify-center transition-all rounded-full bg-primary-200 p-1"
        >
          <svg viewBox="0 0 320 512" class="w-4 h-4">
            <path
              d="M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4
                            44.1-40.4 74V320c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1
                            58.8-107.7V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80
                            320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
            ></path>
          </svg>
          <span
            class="absolute opacity-0 group-hover:opacity-55 group-hover:-translate-y-6 duration-300 text-sm"
          >
            <b>{{ ayudaText }}</b>
          </span>
        </div>
      </section>
      } @if(cerrar) {
      <img
        src="svg/close.svg"
        alt="Arrow"
        class="transition-all duration-200 w-6 mr-6"
        (click)="otherAction = true; cerrarClick()"
      />
      }
    </div>

    <img
      src="svg/arrow.svg"
      alt="Arrow"
      class="transition-all duration-200"
      [ngClass]="{
        'rotate-90': !show,
        '-rotate-90': show,
        'w-10': !small,
        'w-6': small
      }"
    />
  </div>
  <div [id]="idCollapse" class="hide" [ngClass]="{ show: show }">
    <div>
      <div class="pt-4">
        <ng-template *ngTemplateOutlet="contenidoHtml"></ng-template>
      </div>
    </div>
  </div>
</div>
